import { graphql } from '@apollo/react-hoc';
import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

export const query = gql`
  query GetAllAcounts {
    getAllAccounts {
      id
      business_dba
    }
  }
`;

export function useGetAllAccounts(options = {}) {
  return useQuery(query, { ...options });
}

export default graphql(query, {
  options: () => {
    return {
      variables: {},
      fetchPolicy: 'cache-and-network',
    };
  },
});
